import { render, staticRenderFns } from "./BodyHeader.vue?vue&type=template&id=49f0c678&scoped=true"
import script from "./BodyHeader.vue?vue&type=script&lang=js"
export * from "./BodyHeader.vue?vue&type=script&lang=js"
import style0 from "./BodyHeader.vue?vue&type=style&index=0&id=49f0c678&prod&scoped=true&lang=less"
import style1 from "./BodyHeader.vue?vue&type=style&index=1&id=49f0c678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0c678",
  null
  
)

export default component.exports